import type * as React from "react";

/**
 * Compose multiple refs onto one element — typed, no `any` (this utility
 * retires the four no-explicit-any warnings that lived in Popover's
 * hand-rolled ref merge).
 */
export function mergeRefs<T>(
  ...refs: Array<React.Ref<T> | undefined | null>
): React.RefCallback<T> {
  return (node: T | null) => {
    for (const ref of refs) {
      if (!ref) continue;
      if (typeof ref === "function") ref(node);
      else (ref as React.MutableRefObject<T | null>).current = node;
    }
  };
}
